import apiClient from '../index';

export const fundApi = {
  // Get all funds (contributions)
  getFunds: () => apiClient.get('/funds'),
  
  // Get fund by ID
  getFund: (id) => apiClient.get(`/funds/${id}`),
  
  // Get funds by event
  getFundsByEvent: (eventId) => apiClient.get(`/funds/event/${eventId}`),
  
  // Get funds by pledge
  getFundsByPledge: (pledgeId) => apiClient.get(`/funds/pledge/${pledgeId}`),
  
  // Create new fund contribution
  createFund: (data) => apiClient.post('/funds', data),
  
  // Update fund
  updateFund: (id, data) => apiClient.put(`/funds/${id}`, data),
  
  // Delete fund
  deleteFund: (id) => apiClient.delete(`/funds/${id}`),
  
  // Get all pledgers (people who made pledges)
  getPledgers: () => apiClient.get('/funds/pledgers'),
};

export default fundApi;